import { GA } from '../../feature/google-analytics/ga';

const PROMOTIONAL_BANNER_BASE_EVENT_NAME = 'promotional_banner';

export type EventData = {
  id: string;
  type: string;
  headline: string;
  description: string;
  button_text?: string;
  link_url?: string;
};

const event = (name: string, eventData: EventData) => () => GA.sendEvent({ event_name: name, ...eventData });

export const promotionalBannerLinkClick = (baseEventName = PROMOTIONAL_BANNER_BASE_EVENT_NAME, data: EventData) =>
  event(`${baseEventName}_${data.type}_link_click`, data);
export const promotionalBannerImpression = (baseEventName = PROMOTIONAL_BANNER_BASE_EVENT_NAME, data: EventData) =>
  event(`${baseEventName}_${data.type}_impression`, data);
export const promotionalBannerSecondaryLinkClick = (baseEventName = PROMOTIONAL_BANNER_BASE_EVENT_NAME, data: EventData) =>
  event(`${baseEventName}_${data.type}_secondary_link_click`, data);
